import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackClickedPublicBoardLink } from "@air/analytics";
import { useAirModal } from "@air/provider-modal";
import Router from "next/router";
import { memo, useMemo } from "react";
import { PublicTopBarAccountInfo } from "~/components/Layouts/PublicBoardLayout/PublicTopBarAccountInfo";
import { SignupModal } from "~/components/Modals/SignupModal/SignUpModal";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { useLaunchDarklyFlags } from "~/hooks/useLaunchDarklyFlags";
import { useAccountContext } from "~/providers/AccountProvider";
import { AirLogoLink } from "../shared/components/AirLogoLink";
export const DefaultBanner = /*#__PURE__*/ memo(()=>{
    const { workspaceId, workspaceImage, workspaceName } = usePublicWorkspace();
    const { data: account } = useAccountContext();
    const [showSignUpModal] = useAirModal(SignupModal);
    const { trackClickedPublicBoardLink } = useTrackClickedPublicBoardLink();
    const { hideShortUrlSignUpButton, whiteLabelWorkspaces } = useLaunchDarklyFlags();
    const shouldHideLogo = useMemo(()=>{
        return whiteLabelWorkspaces === null || whiteLabelWorkspaces === void 0 ? void 0 : whiteLabelWorkspaces.includes(workspaceId);
    }, [
        whiteLabelWorkspaces,
        workspaceId
    ]);
    const shouldHideSignUpButton = useMemo(()=>{
        return hideShortUrlSignUpButton === null || hideShortUrlSignUpButton === void 0 ? void 0 : hideShortUrlSignUpButton.includes(workspaceId);
    }, [
        hideShortUrlSignUpButton,
        workspaceId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex size-full items-center justify-between bg-pigeon-900 px-2",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-start",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        alt: "Logo for ".concat(workspaceName),
                        className: "size-8 min-w-[32px] rounded",
                        src: workspaceImage
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mx-2 truncate text-16 font-medium text-grey-11",
                        children: workspaceName
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex shrink-0 items-center gap-4",
                children: [
                    account ? /*#__PURE__*/ _jsx(PublicTopBarAccountInfo, {
                        account: account
                    }) : !shouldHideSignUpButton ? /*#__PURE__*/ _jsx("button", {
                        className: "cursor-pointer px-0.5 text-14 font-semibold text-grey-10 hover:underline",
                        onClick: ()=>{
                            showSignUpModal({
                                ssoCallbackData: {
                                    url: Router.asPath
                                },
                                accountCreationSource: "share-link"
                            });
                            trackClickedPublicBoardLink({
                                name: "clicked login",
                                page_area: "banner",
                                page_type: "public board"
                            });
                        },
                        children: "Sign up"
                    }) : undefined,
                    !shouldHideLogo && /*#__PURE__*/ _jsx(AirLogoLink, {})
                ]
            })
        ]
    });
});
DefaultBanner.displayName = "DefaultBanner";
